import { Redirect } from 'react-router-dom';

import { PATH } from '../constants/path';
import { LOCALES } from '../constants/locale';

import { accountRoutes } from './account';
import { directoryRoutes } from './directory';
import { localizeRoutes } from '../utils/routeUtils';

import AloPage from '../components/pages/alo/AloPage';
import ConfirmationEbonSmsPage from '../components/pages/ebon/sms/ConfirmationEbonSmsPage';
import HomePage from '../components/pages/home/HomePage';
import GuidelinesPage from '../components/pages/GuidelinesPage';
import NotFoundPage from '../components/pages/notfound/NotFoundPage';
import BestOffersPage from '../components/pages/bestoffers/BestOffersPage';
import AccountPage from '../components/pages/account/AccountPage';
import ContactRequestPage from '../components/pages/contactrequest/ContactRequestPage';
import FaqPage from '../components/pages/faq/FaqPage';
import CashbackDirectoryPage from '../components/pages/directory/CashbackDirectoryPage';
import LegalNoticePage from '../components/pages/LegalNoticePage';
import MerchantCardPage from '../components/pages/merchantcard/MerchantCardPage';
import TermsPage from '../components/pages/terms/TermsPage';
import UnsubscribePage from '../components/pages/unsubscribe/UnsubscribePage';
import InterstitielComponent from '../components/pages/interstitiel/InterstitielComponent';
import ToolbarPage from '../components/pages/toolbar/ToolbarPage';
import ToolbarInstallationPage from '../components/pages/toolbar/ToolbarInstallationPage';
import FlashingTicketPage from '../components/pages/flashing-ticket/FlashingTicketPage';
import ValidationEbonPage from '../components/pages/ebon/ValidationEbonPage';
import ConfirmationEbonPage from '../components/pages/ebon/confirmation/ConfirmationEbonPage';
import ErrorEbonPage from '../components/pages/ebon/erreur/ErrorEbonPage';
import TermsOfSalesPage from '../components/pages/termsofsales/TermsOfSalesPage';
import AloConfirmationPage from '../components/pages/alo/AloConfirmationPage';
import SponsorshipPage from '../components/pages/sponsorship/SponsorshipPage';
import LoginPage from '../components/pages/login/LoginPage';
import RegisterPage from '../components/pages/register/RegisterPage';
import PasswordResetInitFormComponent from '../components/pages/resetpassword/PasswordResetInitFormComponent';
import PasswordResetCommitFormComponent from '../components/pages/resetpassword/PasswordResetCommitFormComponent';
import EmailValidationPage from '../components/pages/emailvalidation/EmailValidationPage';
import EmailValidationResendPage from '../components/pages/email-validation-resend/EmailValidationResendPage';
import PrivacyPolicyPages from '../components/pages/privacypolicy/PrivacyPolicyPages';
import ConfirmationKycPage from '../components/pages/ebon/kyc/ConfirmationKycPage';
import DownloadPdfComponent from '../components/pages/ebon/download/DownloadPdfComponent';

/**
 * Routes to be prefixed with locale
 * Put all the primary routes (i.e all the routes that d'on depend on a parent route to be displaying)
 */
const localizableRoutes = [
    {
        path: PATH.HOME_PATH,
        exact: true,
        component: HomePage
    },
    {
        path: PATH.HOW_IT_WORK_PATH,
        exact: true,
        component: BestOffersPage
    },
    {
        path: `${PATH.MERCHANTPAGE_TYPE_PATH}:query`,
        component: MerchantCardPage
    },
    {
        path: PATH.CASHBACK_PATH,
        component: CashbackDirectoryPage
    },
    {
        path: PATH.ACCOUNT_PATH,
        component: AccountPage
    },
    {
        path: PATH.FAQ_PATH,
        exact: true,
        component: FaqPage
    },
    {
        path: PATH.LEGAL_NOTICE_PATH,
        exact: true,
        component: LegalNoticePage
    },
    {
        path: PATH.TERMS_PATH,
        exact: true,
        component: TermsPage
    },
    {
        path: PATH.TERMS_OF_SALES,
        exact: true,
        component: TermsOfSalesPage
    },
    {
        path: PATH.PRIVACY_POLICY,
        exact: true,
        component: PrivacyPolicyPages
    },

    {
        path: PATH.TOOLBAR_PATH,
        exact: true,
        component: ToolbarPage
    },
    {
        path: PATH.TOOLBAR_POST_INSTALL_PATH,
        exact: true,
        component: ToolbarInstallationPage
    },
    {
        path: PATH.CONTACTREQUEST_PATH,
        exact: true,
        component: ContactRequestPage
    },
    {
        path: PATH.UNSUBSCRIBE_PATH,
        exact: true,
        component: UnsubscribePage
    },
    {
        path: `${PATH.INTERSTITIEL_CASHBACK_PATH}:partnerId/:clickSource/:username?`,
        component: InterstitielComponent
    },
    {
        path: `${PATH.INTERSTITIEL_TOOLBAR_CASHBACK_PATH}:partnerId/:clickSource/:browser?`,
        component: InterstitielComponent
    },
    {
        path: PATH.FLASHING_TICKET_PATH,
        exact: true,
        component: FlashingTicketPage
    },
    {
        path: `${PATH.EBON_VALIDATION_PATH}/:query`,
        exact: true,
        component: ValidationEbonPage
    },
    {
        path: `${PATH.EBON_CONFIRMATION_PATH}:orderId?`,
        exact: true,
        component: ConfirmationEbonPage
    },
    {
        path: `${PATH.EBON_ERROR_PATH}-:id:paiement?`,
        component: ErrorEbonPage
    },
    {
        path: PATH.ALO_PATH,
        exact: true,
        component: AloPage
    },
    {
        path: PATH.ALO_CONFIRMATION_PATH,
        exact: true,
        component: AloConfirmationPage
    },
    {
        path: `${PATH.VALIDATE_SMS_PATH}/:id`,
        component: ConfirmationEbonSmsPage
    },
    {
        path: PATH.KYC_CONFIRMATION_PATH,
        exact: true,
        component: ConfirmationKycPage
    },
    {
        path: `${PATH.SPONSORSHIP_PATH}`,
        exact: true,
        component: SponsorshipPage
    },
    {
        path: PATH.LOGIN_PATH,
        exact: true,
        component: LoginPage
    },
    {
        path: PATH.REGISTER_PATH,
        exact: true,
        component: RegisterPage
    },
    {
        path: PATH.FORGOTTEN_PASSWORD_PATH,
        exact: true,
        component: PasswordResetInitFormComponent
    },
    {
        path: `${PATH.FORGOTTEN_PASSWORD_PATH}/:email/:token`,
        exact: true,
        component: PasswordResetCommitFormComponent
    },
    {
        path: `${PATH.EMAIL_VALIDATION_PATH}/:email/:token`,
        exact: true,
        component: EmailValidationPage
    },
    {
        path: `${PATH.EMAIL_VALIDATION_RESEND_PATH}`,
        exact: true,
        component: EmailValidationResendPage
    },
    {
        path: `${PATH.PDF_DOWNLOAD_PATH}/:orderId/:pdfType`,
        exact: true,
        component: DownloadPdfComponent
    }
];

export const routes = [
    ...localizableRoutes,
    ...localizeRoutes(LOCALES, localizableRoutes),
    {
        path: '/guidelines',
        exact: true,
        component: GuidelinesPage
    },
    {
        path: PATH.NOT_FOUND_PATH,
        exact: true,
        component: NotFoundPage
    },
    {
        component: Redirect,
        to: PATH.NOT_FOUND_PATH
    }
];

/**
 * First level routes + sub levels routes
 * Mainly used for breadcrumb
 */
const subRoutes = [...accountRoutes, ...directoryRoutes];

export const allRoutes = [...routes, ...subRoutes, ...localizeRoutes(LOCALES, subRoutes)];



// WEBPACK FOOTER //
// ./src/routes/index.js